export default {"src":"/_next/static/media/safari-pinned-tab.c826a54a.svg","height":261,"width":261};